module.exports = "<link-collection> <a href=#!>Inbox<badge new>12</badge></a> <a href=#!>Outbox<badge>22</badge></a> <a href=#!>Draft<badge>2</badge></a> </link-collection>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/badges/badges-in-collections-with-slot.vue
 ** module id = 132
 ** module chunks = 0
 **/